// extracted by mini-css-extract-plugin
export var addToCartButton = "_tk-b";
export var arrowButtonContainer = "_tk-9";
export var arrowButtonIcon = "_tk-a";
export var carouselArrowButton = "_tk-6";
export var carouselElementContainer = "_tk-1";
export var left = "_tk-7";
export var productDisplayCarouselContainer = "_tk-0";
export var productTileContainer = "_tk-2";
export var productTileImage = "_tk-4";
export var productTileImageContainer = "_tk-3";
export var productTileTitle = "_tk-5";
export var right = "_tk-8";
export var sliderOverflow = "_tk-c";